<template>
  <v-dialog
    v-model="dialog"
    v-if="dialog"
    width="1000"
    persistent
  >
    <v-card v-if="step === 0" outlined class="pa-15">
      <div class="text-center text-h5 font-weight-bold" style="color: #803BE8">
        Para começar, escolha um dos planos abaixo:
      </div>
      <div class="d-flex align-center flex-column justify-center mt-8">
        <div class="d-flex">
          <div style="width: 270px;" class="d-flex flex-column align-center" v-for="(plan, index) in plans" :key="index">
            <div>
              <div class="d-flex flex-column" style="line-height: 1">
                <span class="text-h4 font-weight-bold">{{plan.name}}</span>
                <span style="position: relative; top: -5px" class="text-h6 font-weight-bold">anual</span>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bold text-h4" style="color: #00C57E;">12x R$ {{Math.round(plan.monthly_price / 100)}}</span>
                <span class="font-weight-bold">ou R$ {{Math.round(plan.annual_price / 100)}} à vista</span>
              </div>
              <div class="d-flex flex-column mt-3" style="line-height: 1.8">
                <span>{{plan.max_users}} usuário{{plan.max_users > 1 ? 's' : ''}}</span>
                <span>Cliques ilimitados</span>
                <span>{{plan.max_domains}} domínios</span>
                <span v-if="plan.max_links >= 1000000">Links ilimitados</span>
                <span v-else>{{plan.max_links}} links</span>
                <span>{{plan.max_pages}} page{{plan.max_pages > 1 ? 's' : ''}} (em breve)</span>
                <span>Servidor Google</span>
                <span class="pointer font-italic" :loading="loading" @click="openInNewTab('https://zaper.in/#planos')">+ Todas funções</span>
              </div>
            </div>
            <v-btn class="mt-5" color="#00C57E" :outlined="index !== 1" depressed dark @click="activateTrial(plan.id)">Teste grátis por 7 dias</v-btn>
          </div>
        </div>
        <div class="mt-8 caption font-italic text-center">
          <span>Não é necessário cadastrar cartão de crédito para testar :)</span>
        </div>
      </div>
    </v-card>
    <v-card v-if="step === 1" outlined>
      <div style="max-width: 650px;" class="pa-15">
        <div>
          <img src="/img/logo.png" style="height: 60px;" />
        </div>
        <div class="text-h3 mt-7" style="line-height: 1.2">
          Obrigado por ter 
          escolhido a <strong class="font-italic" style="font-family: Rubik; font-weight: 700; color: #00C57E;">ZAPER</strong> para
          gerenciar os seus links!
        </div>
        <div class="text-h4 mt-7 grey--text text--darken-3">
          Para sua melhor experiência em
          na plataforma recomendamos
          que faça as etapas seguintes.
        </div>
      </div>
      <v-divider></v-divider>
      <div class="pa-3 d-flex justify-end">
        <v-btn text @click="step = 2">
          Próximo <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-card>
    <v-card v-if="step === 2" outlined>
      <div class="d-flex justify-center align-center" style="height: 530px;">
        <div style="max-width: 570px;">
          <div class="d-flex align-center">
            <v-icon size="50" color="#00C57E">mdi-web</v-icon>
            <div class="ml-5 title font-weight-bold">
              Verifique o seu domínio/subdomínio para tornar seus links profissionais
            </div>
          </div>
          <div class="d-flex align-center mt-8">
            <v-icon size="50" color="#00C57E">mdi-cog</v-icon>
            <div class="ml-5 title font-weight-bold">
              Se for usar os links em campanhas do Facebook ads, faça a configuração entre Facebook e Zaper
            </div>
          </div>
          <div class="d-flex align-center mt-8">
            <v-icon size="50" color="#00C57E">mdi-television-play</v-icon>
            <div class="ml-5 title font-weight-bold">
              Tem dúvida sobre configurações ou funcionalidades? Assista os vídeos tutoriais que estão na seção Aprender e praticar.
            </div>
          </div>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="pa-3 d-flex justify-end">
        <v-btn text color="#00C57E" @click="dialog = false">
          Entendi
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import PlanService from '@/services/PlanService'
import moment from 'moment'

export default {
  data () {
    return {
      dialog: false,
      plans: [],
      loading: false,
      step: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    }
  },
  watch: {
    user: {
      immediate: true,
      handler: function (user) {
        if (user && !this.dialog) {
          this.dialog = (!user.trial_used && moment(this.user.active_plan_at || 0).valueOf() < Date.now() && user.accepted_terms)
        }
      }
    },
    dialog: {
      immediate: true,
      handler: function (dialog) {
        if (dialog) {
          this.fetchPlans()
        }
      }
    }
  },
  methods: {
    async fetchPlans () {
      this.loading = true
      this.plans = await PlanService.index()
      this.plans.sort((a, b) => a.annual_price - b.annual_price)
      this.loading = false
    },
    async activateTrial (id) {
      this.loading = true
      try {
        await this.$store.dispatch('auth/activateTrial', id)
        this.step = 1
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    openInNewTab (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>